import * as types from '../actionTypes/CreateSessionPostOrderActionTypes';

export default function CreateSessionPostOrderReducer(state = [], action) {
    // NOSONAR
    switch (action.type) {
        case types.CREATE_SESSION_POST_REQUEST_SUCCESS:
            return [...state, action.createSessionPostOrderData];
        case types.CREATE_SESSION_POST_REQUEST_ERROR:
            return [...state, action.createSessionPostOrderError];
        default:
            return state;
    }
}
